import { __assign, __extends } from "tslib";
import React from "react";
import { withLocale } from "./TargemProvider";
var TBase = /** @class */ (function (_super) {
    __extends(TBase, _super);
    function TBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TBase.prototype.render = function () {
        var _a = this.props, children = _a.children, Component = _a.component, componentProps = _a.componentProps, context = _a.context, count = _a.count, formatNumbers = _a.formatNumbers, message = _a.message, messagePlural = _a.messagePlural, scope = _a.scope, tn = _a.tn, tnf = _a.tnf;
        var translate = formatNumbers ? tnf : tn;
        var translation = translate(message || children || "", messagePlural || "", count == null ? 1 : count, scope, context, typeof formatNumbers === "boolean" ? undefined : formatNumbers);
        return Component ? (
        // tslint:disable-next-line: no-unsafe-any
        React.createElement(Component, __assign({}, componentProps), translation)) : (translation);
    };
    return TBase;
}(React.PureComponent));
export { TBase };
// This type cast is needed because TProps type is declared in such
// way that it requires either `children` or `message` props to be passed.
export var T = withLocale(TBase);
//# sourceMappingURL=T.js.map